
import GeoJSON from 'ol/format/GeoJSON';

import MapCommand from './MapCommand';

export default class MapCommandSetTempFeature extends MapCommand {

    constructor(options) {
        super(options);
        this._name = 'SET_TEMP_FEATURE';
    }

    execute(olMap, params) {
        let source = olMap.getTempLayer().getSource();
        source.clear();

        let features = [];
        if (params) {
            if (!params.features) {
                if (params.geoJson || params.geoJsons) {
                    let format = new GeoJSON();
                    features = (params.geoJsons || [params.geoJson]).map(item => {
                        return format.readFeature(item);
                    });
                }
            } else {
                features = params.features;
            }
        }
        features.forEach(item => {
            source.addFeature(item);
        });
    }
}
